<template>
  <div class="grow">
    <slot />
  </div>
</template>

<script>
export default {};
</script>
